/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdDocumentsQueryResponse,
  GetApiV1PersonIdDocumentsPathParams,
  GetApiV1PersonIdDocuments401,
  GetApiV1PersonIdDocuments404,
  GetApiV1PersonIdDocuments500,
} from "../../types/personRegisterController/GetApiV1PersonIdDocuments.ts";

function getGetApiV1PersonIdDocumentsUrl(
  id: GetApiV1PersonIdDocumentsPathParams["id"],
) {
  const res = { method: "GET", url: `/api/v1/person/${id}/documents` as const };
  return res;
}

/**
 * @description Retorna os dados de documentos de uma pessoa (CPF, RG, passaporte, CRNM, CIN). **(Requer Authorization para autenticação)**
 * @summary Obter dados de documentos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/documents}
 */
export async function getApiV1PersonIdDocuments(
  id: GetApiV1PersonIdDocumentsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdDocumentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdDocuments401
      | GetApiV1PersonIdDocuments404
      | GetApiV1PersonIdDocuments500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdDocumentsUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
